import { apiClient } from '@/services/ApiClient.js'

export default {
  getQuestion(id) {
    return apiClient
      .get('questions/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQuestions() {
    return apiClient
      .get('questions')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQuestionsByTarget(target) {
    return apiClient
      .get('questions?target=' + target)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteQuestion(id) {
    return apiClient
      .delete('questions/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createQuestion(question) {
    return apiClient
      .post('questions', question)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sortQuestion(params) {
    return apiClient
      .patch('questions/sort', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getChoices(questionId) {
    return apiClient
      .get('questions/' + questionId + '/choices')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRequirements(questionId) {
    return apiClient
      .get('questions/' + questionId + '/requirements')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteRequirement(questionId, requirementId) {
    return apiClient
      .delete('questions/' + questionId + '/requirements/' + requirementId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getChoice(questionId, id) {
    return apiClient
      .get('questions/' + questionId + '/choices/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editChoice(questionId, id, choice) {
    return apiClient
      .patch('questions/' + questionId + '/choices/' + id, choice)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createChoice(questionId, choice) {
    return apiClient
      .post('questions/' + questionId + '/choices', choice)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createSubCategoryRequirement(questionId, subCategories) {
    return apiClient
      .post('questions/add-requirements', {
        question_id: questionId,
        requirements: subCategories
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createChoiceRequirement(choiceId, question) {
    return apiClient
      .post('choices/' + choiceId + '/requirement', question)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
